/**
 * Enum for user claims
 * @readonly
 * @enum {string}
 */
const USER_CLAIMS = Object.freeze({
    MY_PROFILE: 'My Profile',
    VIEW_PAYMENTS: 'View Payments',
    VIEW_LEVY_ROLL: 'View Levy Roll',
    REGISTER_TENANT: 'Register Tenant',
    VIEW_FINANCIALS: 'View Financials',
    APPROVE_PAYMENTS: 'Approve Payments',
    CLEARANCE_CAPTURE: 'Clearance Capture',
    VIEW_BALANCE_SHEET: 'View Balance Sheet',
    VIEW_PAYMENT_BANDS: 'View Payment Bands',
    VIEW_PROPERTY_LIST: 'View Properties List',
    VIEW_FIRE_COMPLIANCE: 'View Fire Compliance',
    VIEW_INCOME_STATEMENT: 'View Income Statement',
    VIEW_INCOME_VS_BUDGET: 'View Income VS Budget',
    APPROVE_PAYMENT_BANDS: 'Approve Payment Bands',
    VIEW_CONTRACTORS_ROLL: 'View Contractors Roll',
    VIEW_ACCOUNTS_HISTORY: 'View Accounts History',
    VIEW_BUILDING_DOCUMENTS: 'View Building Documents',
    VIEW_CASHFLOW_STATEMENT: 'View Cashflow Statement',
    VIEW_CASHFLOW_STATEMENT_NEW: 'View Cashflow Statement New',
    VIEW_PERSONAL_DOCUMENTS: 'View Personal Documents',
    REJECT_FINANCIAL_SUMMARY: 'Reject Financial Summary',
    VIEW_CONTRACTUAL_PAYMENTS: 'View Contractual Payments',
    APPROVE_FINANCIAL_SUMMARY: 'Approve Financial Summary',
    QUERY_FIRE_QUOTE_COMPLIANCE: 'Query Fire Quote Compliance',
    APPROVE_CONTRACTUAL_PAYMENTS: 'Approve Contractual Payments',
    APPROVE_FIRE_QUOTE_COMPLIANCE: 'Approve Fire Quote Compliance',
    QUERY_MINI_SUB_QUOTE_COMPLIANCE: 'Query Mini-Sub Quote Compliance',
    APPROVE_MINI_SUB_QUOTE_COMPLIANCE: 'Approve Mini-Sub Quote Compliance',
    UTILITY: 'Utility Info',
    VIEW_DOCUMENTS_APPROVAL : 'View Documents Approval',
    CAPTURE_PAYMENTS: 'Capture Payment',
    VIEW_LEGAL_COLLECTIONS_ROLL: 'View Collections Legal Roll',
    RENTALS_CAPTURE: 'Rentals Capture',
    VIEW_WAGES_ROLL: 'View Wages Roll',
    DEBTOR_AGE_ANALYSIS: 'Debtor Age Analysis',
    VIEW_PREVIOUS_FINANCIALS: 'View Previous Financials',
    SHOW_FIND_A_CONTRACTOR: 'Show Find A Contractor',
    BOOKKEEPER_APPROVE_FINANCIAL_SUMMARRY: 'Bookkeeper Approve Financial Summary',
    BOOKKEEPER_REJECT_FINANCIAL_SUMMARRY: 'Bookkeeper Reject Financial Summary',
    AUDITS_CAPTURE: 'Audits Capture',
    AUDITORS_DASHBOARD: 'Auditors Dashboard',
});

export default USER_CLAIMS;
